define("shared/utils/object-methods/object-camel-to-snake", ["exports", "lodash", "shared/utils/string-formatters/camel-to-snake"], function (_exports, _lodash, _camelToSnake) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"lodash",0,"shared/utils/string-formatters/camel-to-snake"eaimeta@70e063a35619d71f
  /**
   * Calls camelToSnake on all keys in given object
   */
  const objectCamelToSnake = data => {
    if (Array.isArray(data)) {
      return data.map(item => objectCamelToSnake(item));
    } else if ((0, _lodash.isObject)(data)) {
      return Object.entries(data).reduce((acc, _ref) => {
        let [key, value] = _ref;
        acc[(0, _camelToSnake.default)(key)] = objectCamelToSnake(value);
        return acc;
      }, {});
    }
    return data;
  };
  var _default = _exports.default = objectCamelToSnake;
});